export default {seo:{title:'Associated Profiles',description:null},title:'Associate a Senskle Profile'};